import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import { Close as CloseIcon } from '@opengov/react-capital-assets';
import DOMPurify from 'dompurify';
import React from 'react';
import { Portal } from 'react-portal';
import { ExplainThisMessages } from '../../../types';
import { styles } from './AiExplainThisModal.styles';

type Props = {
  closeModal(): void;
  messages: ExplainThisMessages;
  explanation: string;
};

// AI responses are plain prose/lists at most, so no attributes are allowed on any tag.
const ALLOWED_EXPLANATION_TAGS = ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'code', 'pre', 'blockquote', 'span'];

export function sanitizeExplanation(explanation: string): string {
  return DOMPurify.sanitize(explanation, {
    ALLOWED_TAGS: ALLOWED_EXPLANATION_TAGS,
    ALLOWED_ATTR: []
  });
}

export function AiExplainThisModal({ closeModal, explanation, messages }: Props) {
  return (
    <Portal>
      <Dialog open={true} onClose={closeModal} fullWidth maxWidth="sm" data-test="ai-explain-this-modal" aria-labelledby="ai-explain-this-dialog-title">
        <DialogTitle id="ai-explain-this-dialog-title" sx={styles.dialogTitle}>
          {messages.explainThis}
          <IconButton aria-label="close" onClick={closeModal} size="small" sx={styles.closeButton}>
            <SvgIcon component={CloseIcon} inheritViewBox />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={styles.container}>
            <Box component="p" sx={styles.label}>{messages.heresWhatWeFound}</Box>
            <Box sx={styles.explanation}>
              <div dangerouslySetInnerHTML={{ __html: sanitizeExplanation(explanation) }} />
            </Box>
            <Box sx={styles.buttons}>
              <Button variant="contained" color="primary" size="small" onClick={() => closeModal()} data-test="ai-explain-this-ok">
                {messages.okay}
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Portal>
  );
}
